
import('./pbds-search.css');
//import('../pb23-search-card--product/pb23-search-card--product.css');
//import('../pb23-search-card--line/pb23-search-card--line.css');
import { initLazyLoad, callPinterestAPI, initComponentsPbds  } from "@api/utils_2020";

const pbdsSearch = {
    page: 1,
    service: null,
    loadedReleases: false,
    init: function () {
        pbdsSearch.initService();
        // pbdsSearch.checkSalesChannel();

        var queries = localStorage.getItem('recentSearches');

        if (queries) {
            var allSearches = JSON.parse(queries);

            if (allSearches.length > 10) {
                allSearches.shift()
            }

            const newQueriesJson = JSON.stringify(allSearches);
            localStorage.setItem('recentSearches', newQueriesJson);
        }

        var searches = pbdsSearch.getSearches();
        pbdsSearch.composeTags(searches);
        $('#pb-searchlayer input[name="q"]').on('keypress', function(e)
        {
            if ($(this).val().length > 0)
            {
                $('.jsClearSearch').show();
                $('.jsSubmitSearch').show();
            }
            else
            {
                $('.jsClearSearch').hide();
                $('.jsSubmitSearch').hide();
            }
        });
/*
        $('.pbds-filters--full .jsAuxmenuToggle').on('click',function(){
            var target = "#" + $(this).attr('data-target');
            console.log("Ok: "+target);            
            if ($(window).width() > 601) {
                $(target).show(function(){$(target).find('.auxmenu--wrapper').toggle("drop",{direction:'right'},500)});
                return false;
            } else {
                $(target).show(function(){$(target).find('.auxmenu--wrapper').toggle("drop",{direction:'down'},500)});
                return false;
            }
        });
        $('.pbds-filters--full .jsAuxmenuClose').on('click', function(){
            if ($(window).width() > 601) {
                $(this).closest(".pbds-auxmenu").find('.auxmenu--wrapper').toggle("drop",{direction:'right'},500,function(){$(this).closest(".pbds-auxmenu").hide();});
                return false;
            } else {
                $(this).closest(".pbds-auxmenu").find('.auxmenu--wrapper').toggle("drop",{direction:'down'},500,function(){$(this).closest(".pbds-auxmenu").hide();});
                return false;
            }
        });

        $('body').off('click','.pbds-filters--full .jsSubmenu').on('click','.pbds-filters--full .jsSubmenu',function(e){
            e.preventDefault();
            var ele = $(this);
            var target = $(this).data('target');
            
            if (ele.hasClass('visible'))
            {
                ele.removeClass('visible');
                ele.siblings('.pbds-submenu').hide("blind",300);
                return false;
            }
            else
            {
                if (!pbdsFiltersFull.mobileAndTabletCheck())
                {
                    $('.pbds-submenu').hide();
                }
                ele.siblings('.pbds-submenu').show("blind",300);
                ele.addClass('visible');
                return false;
            }
        
            return false;
        });*/

        $("#pb-searchlayer .jsClearSearch").on("click", function (e) {
            e.preventDefault();
            $('#pb-searchlayer .jsSearchInput').val('');
            $('#pb-searchlayer .results--autocomplete').hide();
            $("#pb-searchlayer .search-wrapper--preview .results--wrapper").fadeIn();
            return false;
        });
        // open search
        $(".pbds-mainmenu .jsSearch").on("click", function (e) {
            e.preventDefault();
            $("body").addClass("noscroll");
            //$("#pb-searchlayer").animate({ width: "toggle" });
            $("#pb-searchlayer").show("slide", { direction: "up", easing: "swing" }, 200);
            $(".jsSearchInput").focus();
            $("body").addClass("showModal");

            //pbdsSearch.getReleases();

            return false;
        });

        $('.pbds-search--header form').on('submit', function(e)
        {
            var query = $('.pbds-search--header .jsSearchInput').val();
            pbdsSearch.storeSearch(query);
        });
        $('.pbds-search-container form').on('submit', function(e)
        {
            var query = $('.pbds-search-container .jsSearchInput').val();
            pbdsSearch.storeSearch(query);
        });

        $('body').off('click', '.pbds-search--tags .jsSearchByTag').on('click', '.pbds-search--tags .jsSearchByTag', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var query = $(this).data('query');
            $("#pb-searchlayer input.jsSearchInput").val(query).trigger('keyup');
            return false;
        });

        $('body').off('click', '.pbds-search--tags .jsRemoveTag').on('click', '.pbds-search--tags .jsRemoveTag', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var tag = $(this).parents('.jsSearchByTag').data('query');
            pbdsSearch.deleteSearch(tag);
            $(this).parents('.jsSearchByTag').remove();

            var tags = $('.pbds-search--tags .jsSearchByTag');
            if (tags.length == 0) {
                tags.parents('.jsTags').hide();
            }

            return false;
        });

        // close search
        $(".jsSearchClose").on("click", function (e) {
            e.preventDefault();
            //$("#pb-searchlayer").animate({ width: "toggle" });
            $("#pb-searchlayer").hide("slide", { direction: "up", easing: "swing" }, 200);
            $("body").removeClass("noscroll");
            $("body").removeClass("showModal");

            return false;
        });
        $(".jsFilterChannel").on("click",function(){
            $(this).parent().toggleClass("show");
            return false;
        })
        $('body').off("change", ".jsChannel").on("change", ".jsChannel", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $("#pb-searchlayer input.jsSearchInput").trigger('keyup');
            return false;
        })

        let searchTimer;
        let lastQuery;
        var lastChannel = "";
        $("body").on("keyup", "#pb-searchlayer input.jsSearchInput", function (e) {
            const productFields = {
                0: "description",
                1: "nominal_format",
                2: "link",
                3: "id",
                4: "code",
                5: "slug",
                7: "release",
                8: "zoomImageSize",
                9: "zoomImage",
                10: "line",
                12: "brand",
                13: "type",
                14: "suffix",
                15: "name",
                16: "class_portfolio",
                17: "zoomImageLandscape",
                Line: ["name", "slug"],
                ProductFinishing: ["id", "name"],
            };
            const productGroupFields = {
                0: "name",
                1: "mainImage",
                2: "slug",
                3: "link",
                4: "linkFull",
                5: "firstProduct",
                6: "salesChannel",
                7: "totalProducts"
            };
            const query = $(this).val();
            const limit = 4;

            if (e.keyCode == 13) {
                var urlSearch = $(".pbds-search-container form").attr("action");
                pbdsSearch.storeSearch(query);
                window.location.href = `${urlSearch}?q=${query}`;
            } else {
                //var channel = $('.jsChannel:checked').val()
                const urlParams = new URLSearchParams(window.location.search);
                var channel = urlParams.get('channel');
                if (query.length >= 3 && (query != lastQuery || lastChannel != channel)) {
                    clearTimeout(searchTimer);

                    lastChannel = channel;
                    
                    $("#pb-searchlayer .pbds-search-container .jsLoadingReleases").remove();
                    $("#pb-searchlayer .pbds-search-container .search-suggestions.results").remove();
                    $("#pb-searchlayer .search-suggestions.loading").fadeIn("fast");
                    $(".pbds-search--tags").parents('.jsTags').hide();

                    lastQuery = query;

                    searchTimer = setTimeout(function () {
                        var sort = null;

                        if (pbdsSearch.service == null) {
                            UtilUi.alert({
                                title: "Aviso!",
                                message: "Tente novamente em alguns segundos"
                            }, 'warning');
                            return false;
                        }

                        // autocomplete
                        // ($q, $channel, $lang = 'pt_BR', $limit = null)
                        $("#pb-searchlayer .search-wrapper--preview .results--wrapper").fadeOut();
                        pbdsSearch.service.searchAutocomplete(query, null, lang, 10, {
                            // service.getSuggestedSearchedResults(query, limit, productGroupFields, {
                            success: function (results) {
                                pintrk('track', 'search', {
                                    event_id: eventID,
                                    search_query: query
                                });
                                callPinterestAPI('search', { search_query: query });
                                UtilUi.loadTemplate("assets/components-new/pbds-search/pbds-search--autocomplete.tpl", (dataOn, tpl) => {
                                    let html = tpl.fetch({ 
                                        query: query,
                                        results: results,
                                        pathPrefix: pathPrefix
                                     });
                                    $("#pb-searchlayer .results--autocomplete").html(html);
                                    $("#pb-searchlayer .results--autocomplete").show();
                                });
                                
                                console.log(results);
                            }
                        });
                    }, 1500);
                }
            }
        });

    },
    checkSalesChannel: () => {
        var queryString = window.location.search;

        if (queryString.includes("channel=")) {
            var channelValue = new URLSearchParams(queryString).get("channel");
            $('.jsChannel[data-name="' + channelValue + '"]').prop('checked', true);
        } else {
            var channelValue = "";
            $('.jsChannel[data-name="' + channelValue + '"]').prop('checked', true);
        }
    },
    storeSearch: query => {
        //alert('store: ' +query);
        var recentSearches = pbdsSearch.getSearches();
        if (!recentSearches.includes(query)) {
            recentSearches.push(query);
            localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
        }
    },
    getSearches: () => {
        const storedSearches = localStorage.getItem('recentSearches');
        //console.log(storedSearches);
        return storedSearches ? JSON.parse(storedSearches) : [];
    },
    deleteSearch: query => {
        var recentSearches = pbdsSearch.getSearches();
        var index = recentSearches.indexOf(query);
        if (index !== -1) {
            recentSearches.splice(index, 1);
            localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
        }
    },
    composeTags: searches => {
        if (searches.length == 0) {
            $('.preresults--group.recent').hide();
        }
        else
        {
            var max = searches.length;
            var limit = max - 5;
            if (limit <= 0)
            {
                limit = 0;
            }
            
            $('.preresults--group.recent ul').html('');
            for (var x=max-1;x>=limit;x--)
            {
                $('.preresults--group.recent ul').append('<li><a href="/busca-nova/resultados/?q='+searches[x]+'">'+searches[x]+'</a></li>')
            }
            $('.preresults--group.recent').show();
        }
        /*
        UtilUi.loadTemplate(
            "assets/components-new/pbds-search--tags/pbds-search--tags.tpl",
            function (dataOn, tpl) {
                const htmlContent = tpl.fetch({
                    tags: searches,
                });

                initComponentsPbds('pbds-search--tags');
                $(".pbds-search-container .jsTags").html(htmlContent);
            }
        );*/

    }
    /*,
    getReleases: () => {
        
        if (pbdsSearch.loadedReleases) {
            return false;
        }
        var lineFields = [
            'id',
            'name',
            'link',
            'medioImage',
            'medioImageShop',
            'medioImageRevendas', //mmultimarcas
            'medioImageConstrutoras',
            'medioImageExportacao',
            'slogan',
            'slug',
            'salesChannel',
            'totalGroup',
            'totalProducts',
            'new'
        ];
        var filterChannel = `&data[SalesChannel][channel][1]=1`;
        var filterRelease = '&data[Release][1][yes]=1&data[Active][1][yes]=1';
        var filter = filterChannel + filterRelease;

        var channel = $('.jsChannel:checked').val();
        if (!channel && channelSite) {
            channel = channelSite;
        }
      
        pbdsSearch.service.getReleases(filter, 1, 5, lineFields, false, false, false, null, {
            success: function (results) {
                // console.log(results[0].results)
                // console.log(results[1].results)
                // console.log('...')
                UtilUi.loadTemplate(
                    "assets/components-new/pbds-search/pbds-search--results-releases.tpl",
                    function (dataOn, tpl) {
                        const htmlContent = tpl.fetch({
                            searchResultsLines: results[0].results,
                            searchResultsProductGroupColors: results[1].results,
                            urlHome: urlhome,
                            serverName: serverName,
                            urlImageServer: urlImageServer,
                            pathPrefix: pathPrefix,
                            channel: channel,
                            currentChannel: $('.jsChannel:checked').attr('data-name'),
                            channelArr: { id: channel, name: $('.jsChannel:checked').attr('data-name') },
                        });
                        $("#pb-searchlayer .pbds-search-container .jsLoadingReleases").remove();
                        $("#pb-searchlayer .pbds-search-container .search-suggestions.results").remove();
                        $("#pb-searchlayer .pbds-search-container").append(htmlContent);
                        initLazyLoad();
                    }
                );
                pbdsSearch.loadedReleases = true;
                // console.log(results);
                // console.log(pathPrefix);
                // console.log('lines lançammentos')
            }
        });
        
    }*/,
    initService: () => {
        Util.service("WSPortobelloSite", true, {
            exceptionHandler: alertInterface.showError,
            reflectSuccess: function (service) {
                pbdsSearch.service = service;
                /* pbdsSearch.getReleases(); */
            },
            reflectError: function () {
                alert(_t("Erro de conexão, verifique sua conexão com a internet."));
                window.reload();
            },
        });
    },
    ksort: (obj) => {
        var keys = Object.keys(obj);
        keys.sort();
        var sortedObj = {};
        keys.forEach(function (key) {
            sortedObj[key] = obj[key];
        });
        return sortedObj;
    }

}

// initialize component
window.loadedComponents.push({ component: 'pbds-search', init: pbdsSearch.initService });

export default () => {
    pbdsSearch.init();
}